import {
  SET_COMMENTS,
  SET_IS_MESSAGE_BEING_EDITED,
  SET_COMMENTS_LOADING,
  SET_ENTITY_ID,
  SET_EDITED_COMMENT,
  SET_ERROR,
  SET_PAGE,
  SET_MAX_PAGE,
  RESET_COMMENTS_DATA, SET_CURRENT_COMMENT,
} from './actionTypes';

export const setEntityIdAction = (payload) => {
  return {
    type: SET_ENTITY_ID,
    payload,
  };
};

export const setCommentsAction = (payload) => {
  return {
    type: SET_COMMENTS,
    payload,
  };
};

export const setCommentsLoadingAction = (payload) => {
  return {
    type: SET_COMMENTS_LOADING,
    payload,
  };
};

export const setEditedCommentAction = (payload) => {
  return {
    type: SET_EDITED_COMMENT,
    payload,
  };
};

export const setIsBeingEditedMessageAction = (payload) => {
  return {
    type: SET_IS_MESSAGE_BEING_EDITED,
    payload,
  };
};

export const setError = (payload) => {
  return {
    type: SET_ERROR,
    payload,
  };
};

export const setPage = (payload) => {
  return {
    type: SET_PAGE,
    payload,
  };
};

export const setMaxPage = (payload) => {
  return {
    type: SET_MAX_PAGE,
    payload,
  };
};

export const resetCommentsData = (payload) => {
  return {
    type: RESET_COMMENTS_DATA,
    payload: payload,
  };
};

export const setCurrentComment = (payload) => {
  return {
    type: SET_CURRENT_COMMENT,
    payload: payload,
  };
};
